import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { PMS_STATUSES } from 'lumen/utils/constants/pricing-assistant-constants';

export default class PmsVersion extends Model {
  [Type] = 'pms-version' as const;

  @attr('string') declare displayName: string;
  @attr('string') declare pmsStatus: keyof typeof PMS_STATUSES;
}
